import { useEffect, useState } from 'react';
import { useGetSupportedCountries } from './useGetSupportedCountries';
import { ISupportedCountry, UpdateVendorFormFieldsMap, UpdateVendorFormProps } from '../../../interfaces';
import { ExtendedUseFormReturn } from '../../../../../hooks/providers/useFormHooks';

export const useInternationalAddressFieldLogic = (formMethods: ExtendedUseFormReturn<UpdateVendorFormProps>, dynamicCountry: string) => {
  const [selectedCountry, setSelectedCountry] = useState<ISupportedCountry | null>(null);
  const { data: supportedCountries, isRefetching, isLoading } = useGetSupportedCountries();

  const getZipCodeHint = () => {
    if (selectedCountry?.postalCodeValidationExample && selectedCountry?.postalCodeValidationRegex) {
      return `(${selectedCountry.postalCodeValidationExample})`;
    }
    return '';
  };

  useEffect(() => {
    const country = supportedCountries?.supportedCountries.countries.find((c) => c.code === dynamicCountry);
    if (country) {
      if (!country?.subDivisions || !country?.subDivisions?.length) formMethods.setValue(UpdateVendorFormFieldsMap.INTER_STATE, '');
      setSelectedCountry(country);
    }
  }, [dynamicCountry, supportedCountries]);

  return { isLoadingSupportedCountries: isRefetching || isLoading, selectedCountry, getZipCodeHint };
};
